/**
 * Sistem Ayarları › SMS Duyuruları (backlog #643, backend #642): kullanıcılara ve kişilere SMS ile önemli duyuru. E-posta posta listelerinin toplu gönderimi (#585 / #571) gibi:
 *
 *   1) YAZ: Türkçe metin (zorunlu, canlı sayaç: karakter, sayılan, parça, 918 sınırı) ve İngilizce metin (isteğe bağlı: İngilizce okuyan alıcıya gider, yoksa Türkçe).
 *   2) ALICILAR: kayıtlı bir liste (E-posta posta listeleri), kullanıcı süzgeci, kişi süzgeci ya da ikisi birden. Her numara bir kez gider; geçerli cep numarası olmayanlar sayılır, gönderilmez.
 *   3) ÖNİZLE (yazmaz): alıcı sayısı, numarası olmayanlar, tekrarlar, SMS parçası, tahmini maliyet, bakiye. Bakiye yetmiyorsa gönderim açılmaz.
 *      Önizleme yalnız o anki metin ve alıcılar için geçerlidir; ikisinden biri değişirse eskir ve yeniden önizlenmeden gönderilemez.
 *   4) ONAYLA: "bilgilendirme amaçlıdır, ticari değildir" kutusu (kategori HIZMET; ticari mesaj gönderilemez) ve ALICI SAYISININ yazılması (toplu aktivasyon postasındaki gibi).
 *   5) İZLE: ilerleme çubuğu, sayaçlar (gönderilen / başarısız / bloke / bilinmeyen), maliyet; durdurulabilir. Bir kerede tek iş; 5 hatada art arda kendiliğinden durur.
 *      Satıcıdan cevap gelmeyen SMS "bilinmeyen" sayılır ve otomatik tekrar gönderilmez.
 * Geçmiş tablosu önceki duyuruları (kim, ne zaman, kaç kişi, maliyet) gösterir. Sayfa yalnız yeni izni olan (sms.duyuru.gonder) personele açılır.
 */
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, CardBody, CardHeader, Col, Input, Label, Progress, Row, Spinner, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import SmsSayfa from './SmsSayfa';
import SmsMetinSayaci from './SmsMetinSayaci';
import MainContext from '../../../../Components/Contexts/MainContext';
import { olc } from '../../../../services/smsMetin';
import { listMailLists } from '../../../../services/postaListeleriService';
import {
  IS_BITTI, aliciGovdesi, cancelAnnouncementJob, getAnnouncementJob, listAnnouncements, previewAnnouncement, sendAnnouncement,
} from '../../../../services/smsDuyuruService';
import { currentLocaleTag } from '../../../../i18n';

const IZLEME_MS = 2000;
const tarih = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleString(currentLocaleTag()) : '';
};
const para = (n, birim) => (n === null || n === undefined ? '—' : `${Number(n).toLocaleString(currentLocaleTag(), { maximumFractionDigits: 4 })}${birim ? ` ${birim}` : ''}`);

const BOS_FORM = { metinTr: '', metinEn: '', kaynak: 'LIST', listeId: '', yalnizEtkinKullanici: true, fuarSiniri: true, firma: '', salon: '', acil: false };

/** Önizlemenin hangi girdi için alındığını belirleyen anahtar: metin ya da alıcı değişince önizleme eskir. */
export function onizlemeAnahtari(f, fuarId) {
  return JSON.stringify([f.metinTr, f.metinEn, f.acil, alici(f, fuarId)]);
}
export function alici(f, fuarId) {
  return aliciGovdesi({
    kaynak: f.kaynak, listeId: f.listeId, yalnizEtkinKullanici: f.yalnizEtkinKullanici, fuarId: f.fuarSiniri ? fuarId : null, firma: f.firma, salon: f.salon,
  });
}

const SmsDuyurularPage = () => {
  const { t } = useTranslation('sms');
  const { selectedFuarId } = useContext(MainContext) || {};
  const [f, setF] = useState(BOS_FORM);
  const [listeler, setListeler] = useState([]);
  const [onizleme, setOnizleme] = useState(null);       // { anahtar, veri } | { anahtar, hata }
  const [onizliyor, setOnizliyor] = useState(false);
  const [bilgilendirme, setBilgilendirme] = useState(false);
  const [yazilanSayi, setYazilanSayi] = useState('');
  const [gonderiyor, setGonderiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [is, setIs] = useState(null);                    // sürmekte olan / biten işin durumu
  const [isHatasi, setIsHatasi] = useState(null);
  const [gecmis, setGecmis] = useState([]);
  const [gecmisHatasi, setGecmisHatasi] = useState(null);

  const alan = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  useEffect(() => {
    let iptal = false;
    async function calistir() {
      const [l, g] = await Promise.allSettled([listMailLists({ page: 1, limit: 100 }), listAnnouncements({ page: 0, size: 10 })]);
      if (iptal) return;
      if (l.status === 'fulfilled') setListeler(Array.isArray(l.value?.data) ? l.value.data : []);
      if (g.status === 'fulfilled') setGecmis(g.value); else setGecmisHatasi(g.reason.message);
    }
    calistir();
    return () => { iptal = true; };
  }, []);

  // İşin ilerlemesi: sürdüğü sürece izlenir; bitince geçmiş yenilenir.
  const isNo = is && is.job_id;
  const surer = !!is && !IS_BITTI.includes(is.state);
  useEffect(() => {
    if (!isNo || !surer) return undefined;
    let iptal = false;
    const id = setInterval(async () => {
      try {
        const j = await getAnnouncementJob(isNo);
        if (iptal) return;
        setIs(j);
        setIsHatasi(null);
        if (IS_BITTI.includes(j.state)) {
          try { const g = await listAnnouncements({ page: 0, size: 10 }); if (!iptal) setGecmis(g); } catch { /* geçmiş sonra yenilenir */ }
        }
      } catch (e) {
        if (!iptal) setIsHatasi(e.message);
      }
    }, IZLEME_MS);
    return () => { iptal = true; clearInterval(id); };
  }, [isNo, surer]);

  const trOlcu = olc(f.metinTr);
  const enOlcu = olc(f.metinEn);
  const anahtar = onizlemeAnahtari(f, selectedFuarId);
  const guncel = onizleme && onizleme.anahtar === anahtar && onizleme.veri ? onizleme.veri : null;
  const girdiGecerli = f.metinTr.trim() !== '' && !trOlcu.tooLong && trOlcu.desteklenmeyen.length === 0
    && (f.metinEn.trim() === '' || (!enOlcu.tooLong && enOlcu.desteklenmeyen.length === 0))
    && (f.kaynak !== 'LIST' || f.listeId !== '');

  async function onizle() {
    setOnizliyor(true);
    setHata(null);
    const k = anahtar;
    try {
      const veri = await previewAnnouncement({ recipients: alici(f, selectedFuarId), textTr: f.metinTr, textEn: f.metinEn, urgent: f.acil });
      setOnizleme({ anahtar: k, veri });
      setYazilanSayi('');
    } catch (e) {
      setOnizleme({ anahtar: k, hata: e.message });
    } finally {
      setOnizliyor(false);
    }
  }

  const sayiTamam = !!guncel && String(guncel.recipients) === yazilanSayi.trim() && guncel.recipients > 0;
  const gonderilebilir = !!guncel && guncel.enough !== false && bilgilendirme && sayiTamam && !surer && !gonderiyor;

  async function gonder() {
    setGonderiyor(true);
    setHata(null);
    try {
      const sonuc = await sendAnnouncement({ recipients: alici(f, selectedFuarId), textTr: f.metinTr, textEn: f.metinEn, urgent: f.acil, confirmedCount: guncel.recipients });
      setIs({ job_id: sonuc.job_id, state: 'RUNNING', total: guncel.recipients, sent: 0, failed: 0, blocked: 0, unknown: 0, cost: 0 });
      setBilgilendirme(false);
      setYazilanSayi('');
      setOnizleme(null);   // the preview is used up: another send needs a new preview
    } catch (e) {
      setHata(e.status === 409 ? t('duyurular.isSuruyor') : e.message);
    } finally {
      setGonderiyor(false);
    }
  }

  async function durdur() {
    try {
      await cancelAnnouncementJob(isNo);
      setIs(await getAnnouncementJob(isNo));
    } catch (e) {
      setIsHatasi(e.message);
    }
  }

  const islenen = is ? (is.sent || 0) + (is.failed || 0) + (is.blocked || 0) + (is.unknown || 0) : 0;
  const yuzde = is && is.total ? Math.min(100, Math.round((islenen / is.total) * 100)) : 0;

  return (
    <SmsSayfa aktif="duyurular" tabsiz>
      <Alert color="info" fade={false} className="small">{t('duyurular.aciklama')}</Alert>
      {hata && <Alert color="danger" fade={false} data-testid="sms-duyuru-hata">{hata}</Alert>}

      {is && (
        <Card data-testid="sms-duyuru-is">
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">{t('duyurular.ilerleme')}</h5>
            <Badge color={surer ? 'primary' : is.state === 'DONE' ? 'success' : 'warning'} data-testid="sms-duyuru-durum">{t(`duyurular.isDurumu.${is.state}`, { defaultValue: is.state })}</Badge>
          </CardHeader>
          <CardBody>
            <Progress value={yuzde} animated={surer} color={is.state === 'DONE' ? 'success' : 'primary'} className="mb-2">{yuzde}%</Progress>
            <div className="d-flex gap-3 flex-wrap small mb-2" data-testid="sms-duyuru-sayaclar">
              <span>{t('duyurular.sayac.toplam', { sayi: is.total ?? 0 })}</span>
              <span className="text-success">{t('duyurular.sayac.gonderilen', { sayi: is.sent || 0 })}</span>
              <span className="text-danger">{t('duyurular.sayac.basarisiz', { sayi: is.failed || 0 })}</span>
              <span className="text-warning">{t('duyurular.sayac.bloke', { sayi: is.blocked || 0 })}</span>
              <span className="text-muted">{t('duyurular.sayac.bilinmeyen', { sayi: is.unknown || 0 })}</span>
              {is.cost !== undefined && <span>{t('duyurular.sayac.maliyet', { tutar: para(is.cost) })}</span>}
            </div>
            {(is.unknown || 0) > 0 && <div className="small text-muted">{t('duyurular.bilinmeyenNotu')}</div>}
            {is.stopped_reason && <Alert color="warning" fade={false} className="mt-2 mb-0 py-2" data-testid="sms-duyuru-durdu">{is.stopped_reason}</Alert>}
            {isHatasi && <Alert color="danger" fade={false} className="mt-2 mb-0 py-2">{isHatasi}</Alert>}
            {surer && <Button color="danger" outline size="sm" className="mt-3" id="sms-duyuru-durdur" onClick={durdur}>{t('duyurular.durdur')}</Button>}
          </CardBody>
        </Card>
      )}

      <Row>
        <Col lg={7}>
          <Card>
            <CardHeader><h5 className="card-title mb-0">{t('duyurular.yaz')}</h5></CardHeader>
            <CardBody>
              <div className="mb-3">
                <Label htmlFor="sms-duyuru-tr">{t('sablonlar.turkce')}</Label>
                <Input id="sms-duyuru-tr" type="textarea" rows={5} value={f.metinTr} onChange={alan('metinTr')} invalid={trOlcu.tooLong || trOlcu.desteklenmeyen.length > 0} />
                <SmsMetinSayaci metin={f.metinTr} />
              </div>
              <div className="mb-3">
                <Label htmlFor="sms-duyuru-en">{t('sablonlar.ingilizce')}</Label>
                <Input id="sms-duyuru-en" type="textarea" rows={4} value={f.metinEn} onChange={alan('metinEn')} invalid={enOlcu.tooLong || enOlcu.desteklenmeyen.length > 0} />
                <SmsMetinSayaci metin={f.metinEn} />
                <div className="form-text">{t('duyurular.ingilizceNotu')}</div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg={5}>
          <Card>
            <CardHeader><h5 className="card-title mb-0">{t('duyurular.alicilar')}</h5></CardHeader>
            <CardBody>
              <Input id="sms-duyuru-kaynak" type="select" value={f.kaynak} onChange={alan('kaynak')} className="mb-3">
                <option value="LIST">{t('duyurular.kaynak.LIST')}</option>
                <option value="USERS">{t('duyurular.kaynak.USERS')}</option>
                <option value="PERSONS">{t('duyurular.kaynak.PERSONS')}</option>
                <option value="BOTH">{t('duyurular.kaynak.BOTH')}</option>
              </Input>
              {f.kaynak === 'LIST' && (
                <div className="mb-3">
                  <Label htmlFor="sms-duyuru-liste">{t('duyurular.liste')}</Label>
                  <Input id="sms-duyuru-liste" type="select" value={f.listeId} onChange={alan('listeId')}>
                    <option value="">{t('duyurular.listeSecin')}</option>
                    {listeler.map((l) => <option key={l.mail_list_id} value={l.mail_list_id}>{l.mail_list_name} ({l.member_count})</option>)}
                  </Input>
                  <div className="form-text">{t('duyurular.listeNotu')}</div>
                </div>
              )}
              {(f.kaynak === 'USERS' || f.kaynak === 'BOTH') && (
                <div className="form-check mb-2">
                  <Input className="form-check-input" type="checkbox" id="sms-duyuru-etkin" checked={f.yalnizEtkinKullanici} onChange={alan('yalnizEtkinKullanici')} />
                  <Label className="form-check-label" htmlFor="sms-duyuru-etkin">{t('duyurular.yalnizEtkin')}</Label>
                </div>
              )}
              {(f.kaynak === 'PERSONS' || f.kaynak === 'BOTH') && (
                <>
                  <div className="mb-2">
                    <Label htmlFor="sms-duyuru-firma" className="mb-0">{t('duyurular.firma')}</Label>
                    <Input id="sms-duyuru-firma" value={f.firma} onChange={alan('firma')} maxLength={100} placeholder={t('duyurular.firmaIpucu')} />
                  </div>
                  <div className="mb-2">
                    <Label htmlFor="sms-duyuru-salon" className="mb-0">{t('duyurular.salon')}</Label>
                    <Input id="sms-duyuru-salon" value={f.salon} onChange={alan('salon')} maxLength={100} placeholder={t('duyurular.salonIpucu')} />
                  </div>
                </>
              )}
              {f.kaynak !== 'LIST' && (
                <div className="form-check mb-2">
                  <Input className="form-check-input" type="checkbox" id="sms-duyuru-fuar" checked={f.fuarSiniri} disabled={!selectedFuarId} onChange={alan('fuarSiniri')} />
                  <Label className="form-check-label" htmlFor="sms-duyuru-fuar">{t('duyurular.secilenFuar')}</Label>
                </div>
              )}
              <div className="form-check mb-3">
                <Input className="form-check-input" type="checkbox" id="sms-duyuru-acil" checked={f.acil} onChange={alan('acil')} />
                <Label className="form-check-label" htmlFor="sms-duyuru-acil">{t('duyurular.acil')}</Label>
                <div className="form-text">{t('duyurular.acilNotu')}</div>
              </div>
              <Button color="primary" id="sms-duyuru-onizle" disabled={!girdiGecerli || onizliyor} onClick={onizle}>{onizliyor ? <Spinner size="sm" /> : t('duyurular.onizle')}</Button>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {onizleme && (
        <Card data-testid="sms-duyuru-onizleme">
          <CardHeader><h5 className="card-title mb-0">{t('duyurular.onizlemeBasligi')}</h5></CardHeader>
          <CardBody>
            {onizleme.hata && <Alert color="danger" fade={false} className="mb-0">{onizleme.hata}</Alert>}
            {onizleme.veri && (
              <>
                {!guncel && <Alert color="warning" fade={false} data-testid="sms-duyuru-eski">{t('duyurular.onizlemeEskidi')}</Alert>}
                <Row className="mb-2" data-testid="sms-duyuru-sayilar">
                  <Col sm={6} md={3}><div className="text-muted small">{t('duyurular.onizleme.alicilar')}</div><div className="fs-4 fw-semibold" data-testid="sms-duyuru-alici-sayisi">{onizleme.veri.recipients}</div></Col>
                  <Col sm={6} md={3}><div className="text-muted small">{t('duyurular.onizleme.kullanicilar')}</div><div className="fs-5">{onizleme.veri.users ?? 0}</div></Col>
                  <Col sm={6} md={3}><div className="text-muted small">{t('duyurular.onizleme.kisiler')}</div><div className="fs-5">{onizleme.veri.persons ?? 0}</div></Col>
                  <Col sm={6} md={3}><div className="text-muted small">{t('duyurular.onizleme.numarasiz')}</div><div className="fs-5" data-testid="sms-duyuru-numarasiz">{onizleme.veri.without_mobile ?? 0}</div></Col>
                </Row>
                <div className="small mb-2">
                  {t('duyurular.onizleme.tekrar', { sayi: onizleme.veri.duplicates ?? 0 })} · {t('duyurular.onizleme.parcaTr', { sayi: onizleme.veri.parts_tr ?? trOlcu.parts })}
                  {onizleme.veri.parts_en ? ` · ${t('duyurular.onizleme.parcaEn', { sayi: onizleme.veri.parts_en })}` : ''}
                </div>
                <div className="d-flex gap-4 flex-wrap mb-2">
                  <div><div className="text-muted small">{t('duyurular.onizleme.maliyet')}</div><div className="fs-5" data-testid="sms-duyuru-maliyet">{para(onizleme.veri.estimated_cost, onizleme.veri.currency)}</div></div>
                  <div><div className="text-muted small">{t('duyurular.onizleme.bakiye')}</div><div className="fs-5" data-testid="sms-duyuru-bakiye">{para(onizleme.veri.balance, onizleme.veri.currency)}</div></div>
                </div>
                {onizleme.veri.enough === false && <Alert color="danger" fade={false} data-testid="sms-duyuru-yetersiz">{t('duyurular.bakiyeYetmiyor')}</Alert>}
                {onizleme.veri.quiet_hours && !f.acil && <Alert color="warning" fade={false} className="py-2" data-testid="sms-duyuru-sessiz">{t('duyurular.sessizSaat')}</Alert>}
                {onizleme.veri.recipients === 0 && <Alert color="warning" fade={false} className="py-2">{t('duyurular.aliciYok')}</Alert>}
              </>
            )}
          </CardBody>
        </Card>
      )}

      {guncel && guncel.recipients > 0 && (
        <Card data-testid="sms-duyuru-onay">
          <CardHeader><h5 className="card-title mb-0">{t('duyurular.onayBasligi')}</h5></CardHeader>
          <CardBody>
            <div className="form-check mb-3">
              <Input className="form-check-input" type="checkbox" id="sms-duyuru-bilgilendirme" checked={bilgilendirme} onChange={(e) => setBilgilendirme(e.target.checked)} />
              <Label className="form-check-label" htmlFor="sms-duyuru-bilgilendirme">{t('duyurular.bilgilendirme')}</Label>
            </div>
            <div className="mb-3" style={{ maxWidth: 360 }}>
              <Label htmlFor="sms-duyuru-sayi">{t('duyurular.sayiyiYazin', { sayi: guncel.recipients })}</Label>
              <Input id="sms-duyuru-sayi" inputMode="numeric" value={yazilanSayi} onChange={(e) => setYazilanSayi(e.target.value)} invalid={yazilanSayi !== '' && !sayiTamam} />
              <div className="form-text">{t('duyurular.paraNotu', { maliyet: para(guncel.estimated_cost, guncel.currency) })}</div>
            </div>
            {surer && <Alert color="secondary" fade={false} className="py-2">{t('duyurular.isSuruyor')}</Alert>}
            <Button color="danger" id="sms-duyuru-gonder" disabled={!gonderilebilir} onClick={gonder}>{gonderiyor ? <Spinner size="sm" /> : t('duyurular.gonder', { sayi: guncel.recipients })}</Button>
          </CardBody>
        </Card>
      )}

      <Card>
        <CardHeader><h5 className="card-title mb-0">{t('duyurular.gecmis')}</h5></CardHeader>
        <CardBody>
          {gecmisHatasi && <Alert color="danger" fade={false}>{gecmisHatasi}</Alert>}
          <div className="table-responsive">
            <Table hover className="align-middle mb-0" data-testid="sms-duyuru-gecmis">
              <thead><tr><th>{t('kayitlar.zaman')}</th><th>{t('duyurular.kim')}</th><th>{t('sablonlar.turkce')}</th><th>{t('duyurular.onizleme.alicilar')}</th><th>{t('duyurular.sayac.gonderilenKisa')}</th><th>{t('kayitlar.maliyet')}</th><th>{t('kayitlar.durum')}</th></tr></thead>
              <tbody>
                {gecmis.length === 0 && <tr><td colSpan={7} className="text-center text-muted py-3">{t('duyurular.gecmisYok')}</td></tr>}
                {gecmis.map((g) => (
                  <tr key={g.id}>
                    <td className="text-nowrap small">{tarih(g.created_at)}</td>
                    <td>{g.created_by_name}</td>
                    <td className="small" style={{ maxWidth: 320 }}>{g.text_tr}</td>
                    <td>{g.recipients}</td>
                    <td>{g.sent}{g.failed ? <span className="text-danger"> / {g.failed}</span> : null}</td>
                    <td>{para(g.cost)}</td>
                    <td><Badge color={g.state === 'DONE' ? 'success' : g.state === 'RUNNING' ? 'primary' : 'warning'}>{t(`duyurular.isDurumu.${g.state}`, { defaultValue: g.state })}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </SmsSayfa>
  );
};

export default SmsDuyurularPage;
